<template>
  <div class="container">
    <div class="NotFound">
      <p>Aradağınız sayfa bulunamadı</p>
      <router-link to="/" class="button button__red">Anasayfa Dön</router-link>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .NotFound {
    padding: 10rem 0;
    height: 50vh;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a:hover {
      text-decoration: none;
      color: #fff;
    }
    p {
      font-size: 3rem;
      color: #2B2B2B;
      margin-bottom: 4rem;
      text-align: center;
    }
  }
</style>
